import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations';
import { keyedMapSetter } from 'commons/vuex/map/map.js';

const formatFollowers = () => ({
    followers: [],
    following: [],
    followersCount: 0,
    followingCount: 0,
});

export const mutations = {
    [MUTATIONS.UPDATE_FOLLOWS]: keyedMapSetter(Vue, 'user_uuid', formatFollowers),
};
